// WS #2296193 (Modern Financial on Solar, 10-19). An office may keep its own list of Lead Sources; with
// OFFICE_LEAD_SOURCES on, Lead Source is a dropdown of only that list. The server decides again on save.

const listOf = (value) => (Array.isArray(value) ? value.filter((item) => typeof item === 'string' && item.trim()) : [])

// Existing lead: the lead GET (contactGroupConfig.leadSources). New lead: the rep's active office settings.
export const officeLeadSourcesFor = ({ flagOn, createOfficeSettings, contactGroupConfig } = {}) => {
  if (flagOn !== true) return null
  const list = listOf(contactGroupConfig?.leadSources).length > 0
    ? listOf(contactGroupConfig.leadSources)
    : listOf(createOfficeSettings?.leadSources)
  return list.length > 0 ? list : null
}

// A value the lead already has stays a choice, so it still shows and the lead still saves.
export const leadSourceChoices = (list, current) => (current && !list.includes(current) ? [...list, current] : list)
